import { DataBean } from "../../DataBean";


export class IncapacityType extends DataBean {


    public async getIncapacityTypeCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getIncapacityTypeCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}